export default __webpack_public_path__ + "static/IN-9008FHD_Lense-Adjustment-76f413eda73e0b66e3396bafd3111630.png";